import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import tick from "Assets/newicons/config-dashboard/notify-check-tick.svg";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import DynamicForm from "Component/DynamicForm";
import DAYS_LIST from "Constants/DATA/daysList";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { integerinputconverter } from "../../../../../../Component/DynamicForm/Fields/Integer";
import { selectinputconverter } from "../../../../../../Component/DynamicForm/Fields/Select";

let monthlist;

class details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 2,
      selectedReview: props.selectedReview,
      expanded: false,
      options: [],
      day: null,
      month: new Date().getUTCMonth() + 1,
      isPrimaryManager: false,
      isSecondaryManager: false,
      isManagersManager: false,
      participant: props.selectedReview.participant,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onMonthSelect = this.onMonthSelect.bind(this);
  }

  componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });

    // const { participant } = this.props.selectedReview;
    // if (participant != null) {
    //   const participant1 = participant.filter(x => x.participanttypeid == 1);
    //   const participant2 = participant.filter(x => x.participanttypeid == 2);
    //   const participant3 = participant.filter(x => x.participanttypeid == 3);
    //   const participant4 = participant.filter(x => x.participanttypeid == 4);
    //   if (participant1 && participant1.length != null) {
    //     console.log(participant1[0].isSelected);
    //     participant1[0].isSelected = true;
    //     tempparticipant[0] = participant1[0];
    //   } else if (participant2 && participant2.length != null) {
    //     participant2[0].isSelected = true;
    //     tempparticipant[0] = participant2[0];
    //   } else if (participant3 && participant3.length != null) {
    //     participant3[0].isSelected = true;
    //     tempparticipant[0] = participant3[0];
    //   } else if (participant4 && participant4.length != null) {
    //     participant4[0].isSelected = true;
    //     tempparticipant[0] = participant4[0];
    //   }
    // }

    monthlist =
      this.props.selectedReview.reviewperiodtypeid == 2
        ? [
            {
              displayname: "1st",
              displayvalue: 1,
            },
            {
              displayname: "2nd",
              displayvalue: 2,
            },
            {
              displayname: "3rd",
              displayvalue: 3,
            },
          ]
        : this.props.selectedReview.reviewperiodtypeid == 3
        ? [
            {
              displayname: "1st",
              displayvalue: 1,
            },
            {
              displayname: "2nd",
              displayvalue: 2,
            },
            {
              displayname: "3rd",
              displayvalue: 3,
            },
            {
              displayname: "4th",
              displayvalue: 4,
            },
            {
              displayname: "5th",
              displayvalue: 5,
            },
            {
              displayname: "6th",
              displayvalue: 6,
            },
          ]
        : [
            {
              displayname: "1st",
              displayvalue: 1,
            },
            {
              displayname: "2nd",
              displayvalue: 2,
            },
            {
              displayname: "3rd",
              displayvalue: 3,
            },
            {
              displayname: "4th",
              displayvalue: 4,
            },
            {
              displayname: "5th",
              displayvalue: 5,
            },
            {
              displayname: "6th",
              displayvalue: 6,
            },
            {
              displayname: "7th",
              displayvalue: 7,
            },
            {
              displayname: "8th",
              displayvalue: 8,
            },
            {
              displayname: "9th",
              displayvalue: 9,
            },
            {
              displayname: "10th",
              displayvalue: 10,
            },
            {
              displayname: "11th",
              displayvalue: 11,
            },
            {
              displayname: "12th",
              displayvalue: 12,
            },
          ];
  }

  // onSaveDraft() {
  //   const { selectedReview, participant } = this.state;
  //   selectedReview.isdraft = true;
  //   let structure = selectedReview;
  //   const selectedData = participant.filter(x => x.isSelected == true);
  //   structure.participant = selectedData;
  //   instance.post("perform/createreviewstructure", structure)
  //     .then(() => {
  //       this.props.enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
  //       this.props.onCancel();
  //     })
  //     .catch((error) => {
  //       this.props.enqueueSnackbar(
  //         error.response ? error.response.data.error.message : error.message,
  //         { variant: "error" },
  //       );
  //     });
  // }

  handleChange(key, value, participanttypeid) {
    console.log("participanttypeid: ", participanttypeid);
    console.log("value: ", value);
    console.log("key: ", key);
    const { participant, selectedReview } = this.state;

    if (
      selectedReview.formopentypeid == 1 &&
      (key == "openday" || key == "frequencytypeid")
    ) {
      participant[0][key] = value;
      participant[1][key] = value;
      participant[2][key] = value;
      participant[3][key] = value;
    }
    if (key == "isSelected" && selectedReview.isformalwaysopen == true) {
      participant[participanttypeid - 1][key] = value;
      participant[participanttypeid - 1].closeday = 1;
      participant[participanttypeid - 1].openday = 1;
    } else {
      participant[participanttypeid - 1][key] = value;
    }

    console.log(participant[participanttypeid - 1].key, value);
    this.setState({
      participant,
    });
  }

  onSelect(e, key) {
    this.setState({ [key]: e.displayvalue });
  }

  setCurrentPage = (option) => {
    this.setState({ currentPage: option });
  };

  onOpenFormSelect(value) {
    this.setState({
      month: value,
    });
  }

  onMonthSelect(value) {
    this.setState({
      month: value,
    });
  }

  handleExpandClick = (panel) => (event, isExpanded) => {
    // setExpanded(isExpanded ? panel : false); // //previous state manager , now not needed //
    isExpanded
      ? this.setState({ expanded: panel })
      : this.setState({ expanded: false }); // new state manager//
  };

  getReviewProcess(value, key) {
    this.setState({
      [key]: value,
    });
  }

  onSubmit() {
    const { selectedReview, participant } = this.state;
    console.log(participant);
    selectedReview.participant = participant;

    if (selectedReview.reviewperiodtypeid == 1) {
      participant[0].frequencytypeid = 1;
      participant[1].frequencytypeid = 1;
      participant[2].frequencytypeid = 1;
      participant[3].frequencytypeid = 1;
    }
    if (selectedReview.reviewperiodtypeid == null) {
      participant[0].frequencytypeid = null;
      participant[1].frequencytypeid = null;
      participant[2].frequencytypeid = null;
      participant[3].frequencytypeid = null;
    }
    if (
      !participant[0].isSelected &&
      !participant[1].isSelected &&
      !participant[2].isSelected &&
      !participant[3].isSelected
    ) {
      this.props.enqueueSnackbar("Please select atleast one ", {
        variant: "error",
      });
    } else if (
      participant[0].isSelected &&
      selectedReview.reviewtypeid != 2 &&
      ((selectedReview.formopentypeid != 3 && !participant[0].openday) ||
        (selectedReview.reviewperiodtypeid !== 1 &&
          selectedReview.formopentypeid != 3 &&
          !participant[0].frequencytypeid))
    ) {
      this.props.enqueueSnackbar("Please fill all the data of employee ", {
        variant: "error",
      });
    } else if (
      participant[0].isSelected &&
      selectedReview.reviewtypeid != 2 &&
      selectedReview.formopentypeid != 3 &&
      !participant[0].closeday
    ) {
      this.props.enqueueSnackbar("please select review submission close days", {
        variant: "error",
      });
    } else if (
      participant[1].isSelected &&
      selectedReview.reviewtypeid != 2 &&
      ((selectedReview.formclosetypeid != 3 && !participant[1].closeday) ||
        (selectedReview.formopentypeid != 3 && !participant[1].openday) ||
        (selectedReview.reviewperiodtypeid !== 1 &&
          selectedReview.formopentypeid != 3 &&
          !participant[1].frequencytypeid))
    ) {
      this.props.enqueueSnackbar("Please fill all the data of managers ", {
        variant: "error",
      });
    } else if (
      participant[1].isSelected &&
      selectedReview.reviewtypeid != 2 &&
      ((selectedReview.formclosetypeid != 3 && !participant[1].closeday) ||
        (selectedReview.formopentypeid != 3 && !participant[1].openday) ||
        (selectedReview.reviewperiodtypeid !== 1 &&
          selectedReview.formopentypeid != 3 &&
          !participant[1].frequencytypeid) ||
        (!participant[1].isprimarymanager &&
          !participant[1].issecondarymanager &&
          !participant[1].ismanagersmanager))
    ) {
      this.props.enqueueSnackbar(
        "Please select atleast one of the checkbox of managers ",
        { variant: "error" },
      );
    } else if (
      participant[2].isSelected &&
      selectedReview.reviewtypeid != 2 &&
      ((selectedReview.formclosetypeid != 3 && !participant[2].closeday) ||
        (selectedReview.formopentypeid != 3 && !participant[2].openday) ||
        (selectedReview.reviewperiodtypeid !== 1 &&
          selectedReview.formopentypeid != 3 &&
          !participant[2].frequencytypeid))
    ) {
      this.props.enqueueSnackbar("Please fill all the data of reports ", {
        variant: "error",
      });
    } else if (
      participant[3].isSelected &&
      selectedReview.reviewtypeid != 2 &&
      ((selectedReview.formclosetypeid != 3 && !participant[3].closeday) ||
        (selectedReview.formopentypeid != 3 && !participant[3].openday) ||
        (selectedReview.reviewperiodtypeid !== 1 &&
          selectedReview.formopentypeid != 3 &&
          !participant[3].frequencytypeid))
    ) {
      this.props.enqueueSnackbar("Please fill all the data of peer ", {
        variant: "error",
      });
    } else {
      this.props.onNextClick(selectedReview);
    }
  }

  render() {
    const {
      reviewperiodtypeid,
      formopentypeid,
      formclosetypeid,

      reviewtypeid,
    } = this.state.selectedReview;
    const { participant } = this.state;

    return (
      <div className="padding-top-0">
        <div className="stepper-scroller-content">
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              {formopentypeid == 1 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Review submission opening
                  </p>
                  {/* <p className="small-dark-secondary margin-bottom-16">
                    Select from the X months in each [quarter]
                  </p> */}
                  <div
                    className="margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <p className="small-dark-secondary margin-bottom-16">
                      Select from the X day in each month.
                    </p>
                    <div className="display-flex">
                      <div
                        style={{
                          width: 100,
                          marginRight: 8,
                          marginBottom: -16,
                        }}
                      >
                        <DynamicForm
                          fields={selectinputconverter({
                            value:
                              // isformalwaysopen == true
                              //   ? 1
                              //   :
                              participant[0].openday,
                            placeholder: "",
                            label: "",
                            options: DAYS_LIST,
                            // disabled:
                            //   isformalwaysopen == true
                            //     ? true
                            //     : participant[0].isSelected == false
                            //     ? true
                            //     : false,
                          })}
                          onChange={(e) => this.handleChange("openday", e, 1)}
                        />
                      </div>
                      <p className="small-dark">day of that month</p>
                    </div>
                  </div>

                  {reviewperiodtypeid != 1 && (
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ alignItems: "center" }}
                    >
                      <div
                        style={{
                          width: 100,
                          marginRight: 8,
                          marginBottom: -16,
                        }}
                      >
                        <DynamicForm
                          fields={selectinputconverter({
                            value:
                              // isformalwaysopen == true
                              //   ? 1
                              //   :
                              participant[0].frequencytypeid,
                            placeholder: "",
                            label: "",
                            options: monthlist,
                            // disabled:
                            //   isformalwaysopen == true
                            //     ? true
                            //     : participant[0].isSelected == false
                            //     ? true
                            //     : false,
                          })}
                          onChange={(e) =>
                            this.handleChange("frequencytypeid", e, 1)
                          }
                        />
                      </div>
                      <p className="small-dark margin-left-8">
                        month of each [quarter]
                      </p>
                    </div>
                  )}
                </div>
              )}

              {formopentypeid == 3 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Review submission opening
                  </p>
                  <p className="small-dark-secondary margin-bottom-16">
                    First day of the review period, as specified in the previous
                    step.
                  </p>
                </div>
              )}

              {formclosetypeid == 1 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Review submission closing
                  </p>
                  <p className="small-dark-secondary margin-bottom-16">
                    Enter number of days after which review forms should close
                  </p>
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <div style={{ width: 100, marginBottom: -16 }}>
                      <DynamicForm
                        fields={integerinputconverter({
                          value: participant[0].closeday,
                          label: "",
                          min: 1,
                          max: 30,
                          // disabled:
                          //   participant[0].isSelected == false ? true : false,
                        })}
                        onChange={(val) =>
                          this.handleChange("closeday", val, 1)
                        }
                      />
                    </div>
                    <span className="small-dark-secondary margin-left-8">
                      days
                    </span>
                  </div>
                </div>
              )}

              {formclosetypeid == 3 && (
                <div>
                  <p className="normal-dark margin-bottom-8 display-flex">
                    <img
                      className="margin-right-16"
                      src={pointingHandIcon}
                    ></img>{" "}
                    Review submission closing
                  </p>
                  <p className="small-dark-secondary margin-bottom-16">
                    Last day of the review period, as specified in the previous
                    step.
                  </p>
                </div>
              )}

              {(formopentypeid == 2 ||
                formclosetypeid == 2 ||
                reviewtypeid == 2) && (
                <div style={{ marginLeft: 2, marginBottom: 2 }}>
                  {this.props.selectedReview.participant[0].isSelected && (
                    <ExpansionPanel
                      expanded={this.state.expanded === "panel1"}
                      onChange={this.handleExpandClick("panel1")}
                      className="padding0"
                      style={{
                        pointerEvents: reviewtypeid == 2 ? "none" : "",
                        border: "solid 1px #d9dadb",
                        boxShadow: "none",
                        borderBottom: "1px solid #d9dadb",
                      }}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                        style={{
                          cursor: "default",
                          minHeight: 48,
                          maxHeight: 48,
                          borderBottom:
                            this.state.expanded === "panel1"
                              ? "solid 1px #d9dadb"
                              : "solid 0px #d9dadb",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              width: 16,
                              height: 16,
                              margin: "0 16px 0 0",

                              display: "inline-block",
                            }}
                          >
                            <img
                              src={tick}
                              height="16"
                              style={{ marginTop: 2, display: "block" }}
                            ></img>
                          </span>
                          <span className="normal-dark t-bold">
                            Self reviews
                          </span>
                        </div>
                      </ExpansionPanelSummary>
                      {reviewtypeid == 2 ? (
                        ``
                      ) : (
                        <ExpansionPanelDetails className="display-block padding-top-16">
                          {formopentypeid == 2 && (
                            <div>
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission opening
                              </p>
                              <p className="small-dark-secondary margin-bottom-16">
                                Select from the X day in each month.
                              </p>

                              <div
                                className="display-flex margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <div
                                  style={{
                                    width: 100,
                                    marginRight: 8,
                                    marginBottom: -16,
                                  }}
                                >
                                  <DynamicForm
                                    fields={selectinputconverter({
                                      value:
                                        // isformalwaysopen == true
                                        //   ? 1
                                        //   :
                                        participant[0].openday,
                                      placeholder: "",
                                      label: "",
                                      options: DAYS_LIST,
                                      // disabled:
                                      //   isformalwaysopen == true
                                      //     ? true
                                      //     : participant[0].isSelected == false
                                      //     ? true
                                      //     : false,
                                    })}
                                    onChange={(e) =>
                                      this.handleChange("openday", e, 1)
                                    }
                                  />
                                </div>
                                <p className="small-dark">day of that month</p>
                              </div>

                              {reviewperiodtypeid != 1 && (
                                <div
                                  className="margin-bottom-16"
                                  style={{ alignItems: "center" }}
                                >
                                  <p className="small-dark-secondary margin-bottom-16">
                                    Select from the X day in each month.
                                  </p>
                                  <div className="display-flex">
                                    <div
                                      style={{
                                        width: 100,
                                        marginRight: 8,
                                        marginBottom: -16,
                                      }}
                                    >
                                      <DynamicForm
                                        fields={selectinputconverter({
                                          value:
                                            // isformalwaysopen == true
                                            //   ? 1
                                            //   :
                                            participant[0].frequencytypeid,
                                          placeholder: "",
                                          label: "",
                                          options: monthlist,
                                          // disabled:
                                          //   isformalwaysopen == true
                                          //     ? true
                                          //     : participant[0].isSelected == false
                                          //     ? true
                                          //     : false,
                                        })}
                                        onChange={(e) =>
                                          this.handleChange(
                                            "frequencytypeid",
                                            e,
                                            1,
                                          )
                                        }
                                      />
                                    </div>
                                    <p className="small-dark margin-left-8">
                                      month of each [quarter]
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {formclosetypeid == 2 && (
                            <div className="margin-top-32">
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission closing
                              </p>
                              <p className="small-dark-secondary margin-bottom-16">
                                Enter number of days after which review forms
                                should close
                              </p>
                              <div
                                className="display-flex margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <div style={{ width: 100, marginBottom: -16 }}>
                                  <DynamicForm
                                    fields={integerinputconverter({
                                      value: participant[0].closeday,
                                      label: "",
                                      min: 1,
                                      max: 30,
                                      // disabled:
                                      //   participant[0].isSelected == false
                                      //     ? true
                                      //     : false,
                                    })}
                                    onChange={(val) =>
                                      this.handleChange("closeday", val, 1)
                                    }
                                  />
                                </div>
                                <span className="small-dark-secondary margin-left-8">
                                  days
                                </span>
                              </div>
                            </div>
                          )}
                        </ExpansionPanelDetails>
                      )}
                    </ExpansionPanel>
                  )}
                  {this.props.selectedReview.participant[1].isSelected && (
                    <ExpansionPanel
                      expanded={this.state.expanded === "panel2"}
                      onChange={this.handleExpandClick("panel2")}
                      className="padding0"
                      style={{
                        pointerEvents: reviewtypeid == 2 ? "none" : "",
                        border: "solid 1px #d9dadb",
                        boxShadow: "none",
                        borderBottom: "1px solid #d9dadb",
                      }}
                      // style={reviewtypeid == 2 ? {pointerEvents:"none"} : {}}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2bh-content"
                        id="panel2bh-header"
                        style={{
                          cursor: "default",
                          minHeight: 48,
                          maxHeight: 48,
                          borderBottom:
                            this.state.expanded === "panel2"
                              ? "solid 1px #d9dadb"
                              : "solid 0px #d9dadb",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              width: 16,
                              height: 16,
                              margin: "0 16px 0 0",

                              display: "inline-block",
                            }}
                          >
                            <img
                              src={tick}
                              height="16"
                              style={{ marginTop: 2, display: "block" }}
                            ></img>
                          </span>
                          <span className="normal-dark t-bold">
                            Reviews for manager
                          </span>
                        </div>
                      </ExpansionPanelSummary>
                      {reviewtypeid == 2 ? (
                        ""
                      ) : (
                        <ExpansionPanelDetails className="display-block padding-top-16">
                          {formopentypeid == 2 && (
                            <div>
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission opening
                              </p>
                              {/* <p className="small-dark-secondary margin-bottom-16">
                                  Select from the X months in each [quarter]
                              </p> */}
                              <div
                                className="margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <p className="small-dark-secondary margin-bottom-16">
                                  Select from the X day in each month.
                                </p>
                                <div className="display-flex">
                                  <div
                                    style={{
                                      width: 100,
                                      marginRight: 8,
                                      marginBottom: -16,
                                    }}
                                  >
                                    <DynamicForm
                                      fields={selectinputconverter({
                                        value:
                                          // isformalwaysopen == true
                                          //   ? 1
                                          //   :
                                          participant[1].openday,
                                        placeholder: "",
                                        label: "",
                                        options: DAYS_LIST,
                                        // disabled:
                                        //   isformalwaysopen == true
                                        //     ? true
                                        //     : participant[1].isSelected == false
                                        //     ? true
                                        //     : false,
                                      })}
                                      onChange={(e) =>
                                        this.handleChange("openday", e, 2)
                                      }
                                    />
                                  </div>
                                  <p className="small-dark">
                                    day of that month
                                  </p>
                                </div>
                              </div>

                              {reviewperiodtypeid != 1 && (
                                <div
                                  className="display-flex margin-bottom-16"
                                  style={{ alignItems: "center" }}
                                >
                                  <div
                                    style={{
                                      width: 100,
                                      marginRight: 8,
                                      marginBottom: -16,
                                    }}
                                  >
                                    <DynamicForm
                                      fields={selectinputconverter({
                                        value:
                                          // isformalwaysopen == true
                                          //   ? 1
                                          //   :
                                          participant[1].frequencytypeid,
                                        placeholder: "",
                                        label: "",
                                        options: monthlist,
                                        // disabled:
                                        //   isformalwaysopen == true
                                        //     ? true
                                        //     : participant[1].isSelected == false
                                        //     ? true
                                        //     : false,
                                      })}
                                      onChange={(e) =>
                                        this.handleChange(
                                          "frequencytypeid",
                                          e,
                                          2,
                                        )
                                      }
                                    />
                                  </div>
                                  <p className="small-dark margin-left-8">
                                    month of each [quarter]
                                  </p>
                                </div>
                              )}
                            </div>
                          )}

                          {formclosetypeid == 2 && (
                            <div className="margin-top-32">
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission closing
                              </p>
                              <p className="small-dark-secondary margin-bottom-16">
                                Enter number of days after which review forms
                                should close
                              </p>
                              <div
                                className="display-flex margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <div style={{ width: 100, marginBottom: -16 }}>
                                  <DynamicForm
                                    fields={integerinputconverter({
                                      value: participant[1].closeday,
                                      label: "",
                                      min: 1,
                                      max: 30,
                                    })}
                                    onChange={(val) =>
                                      this.handleChange("closeday", val, 2)
                                    }
                                  />
                                </div>
                                <span className="small-dark-secondary margin-left-8">
                                  days
                                </span>
                              </div>
                            </div>
                          )}
                        </ExpansionPanelDetails>
                      )}
                    </ExpansionPanel>
                  )}
                  {this.props.selectedReview.participant[2].isSelected && (
                    <ExpansionPanel
                      expanded={this.state.expanded === "panel3"}
                      onChange={this.handleExpandClick("panel3")}
                      className="padding0"
                      style={{
                        pointerEvents: reviewtypeid == 2 ? "none" : "",
                        border: "solid 1px #d9dadb",
                        boxShadow: "none",
                        borderBottom: "1px solid #d9dadb",
                      }}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                        style={{
                          cursor: "default",
                          minHeight: 48,
                          maxHeight: 48,
                          borderBottom:
                            this.state.expanded === "panel3"
                              ? "solid 1px #d9dadb"
                              : "solid 0px #d9dadb",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              width: 16,
                              height: 16,
                              margin: "0 16px 0 0",

                              display: "inline-block",
                            }}
                          >
                            <img
                              src={tick}
                              height="16"
                              style={{ marginTop: 2, display: "block" }}
                            ></img>
                          </span>
                          <span className="normal-dark t-bold">
                            Reviews for junior employee
                          </span>
                        </div>
                      </ExpansionPanelSummary>
                      {reviewtypeid == 2 ? (
                        ``
                      ) : (
                        <ExpansionPanelDetails className="display-block padding-top-16">
                          {formopentypeid == 2 && (
                            <div>
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission opening
                              </p>
                              {/* <p className="small-dark-secondary margin-bottom-16">
                                  Select from the X months in each [quarter]
                              </p> */}
                              <div
                                className="margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <p className="small-dark-secondary margin-bottom-16">
                                  Select from the X day in each month.
                                </p>
                                <div className="display-flex">
                                  <div
                                    style={{
                                      width: 100,
                                      marginRight: 8,
                                      marginBottom: -16,
                                    }}
                                  >
                                    <DynamicForm
                                      fields={selectinputconverter({
                                        value:
                                          // isformalwaysopen == true
                                          //   ? 1
                                          //   :
                                          participant[2].openday,
                                        placeholder: "",
                                        label: "",
                                        options: DAYS_LIST,
                                      })}
                                      onChange={(e) =>
                                        this.handleChange("openday", e, 3)
                                      }
                                    />
                                  </div>
                                  <p className="small-dark">
                                    day of that month
                                  </p>
                                </div>
                              </div>

                              {reviewperiodtypeid != 1 && (
                                <div
                                  className="display-flex margin-bottom-16"
                                  style={{ alignItems: "center" }}
                                >
                                  <div
                                    style={{
                                      width: 100,
                                      marginRight: 8,
                                      marginBottom: -16,
                                    }}
                                  >
                                    <DynamicForm
                                      fields={selectinputconverter({
                                        value:
                                          // isformalwaysopen == true
                                          //   ? 1
                                          //   :
                                          participant[2].frequencytypeid,
                                        placeholder: "",
                                        label: "",
                                        options: monthlist,
                                      })}
                                      onChange={(e) =>
                                        this.handleChange(
                                          "frequencytypeid",
                                          e,
                                          3,
                                        )
                                      }
                                    />
                                  </div>
                                  <p className="small-dark margin-left-8">
                                    month of each [quarter]
                                  </p>
                                </div>
                              )}
                            </div>
                          )}

                          {formclosetypeid == 2 && (
                            <div className="margin-top-32">
                              <div className="clear-float"></div>
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission closing
                              </p>
                              <p className="small-dark-secondary margin-bottom-16">
                                Enter number of days after which review forms
                                should close
                              </p>
                              <div
                                className="display-flex margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <div style={{ width: 100, marginBottom: -16 }}>
                                  <DynamicForm
                                    fields={integerinputconverter({
                                      value: participant[2].closeday,
                                      label: "",
                                      min: 1,
                                      max: 30,
                                    })}
                                    onChange={(val) =>
                                      this.handleChange("closeday", val, 3)
                                    }
                                  />
                                </div>
                                <span className="small-dark-secondary margin-left-8">
                                  days
                                </span>
                              </div>
                            </div>
                          )}
                        </ExpansionPanelDetails>
                      )}
                    </ExpansionPanel>
                  )}

                  {this.props.selectedReview.participant[3].isSelected && (
                    <ExpansionPanel
                      expanded={this.state.expanded === "panel4"}
                      onChange={this.handleExpandClick("panel4")}
                      className="padding0"
                      style={{
                        pointerEvents: reviewtypeid == 2 ? "none" : "",
                        border: "solid 1px #d9dadb",
                        boxShadow: "none",
                      }}
                    >
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4bh-content"
                        id="panel4bh-header"
                        style={{
                          cursor: "default",
                          minHeight: 48,
                          maxHeight: 48,
                          borderBottom:
                            this.state.expanded === "panel4"
                              ? "solid 1px #d9dadb"
                              : "solid 0px #d9dadb",
                        }}
                      >
                        <div>
                          <span
                            style={{
                              width: 16,
                              height: 16,
                              margin: "0 16px 0 0",

                              display: "inline-block",
                            }}
                          >
                            <img
                              src={tick}
                              height="16"
                              style={{ marginTop: 2, display: "block" }}
                            ></img>
                          </span>
                          <span className="normal-dark t-bold">
                            Reviews for co-worker
                          </span>
                        </div>
                      </ExpansionPanelSummary>

                      {reviewtypeid == 2 ? (
                        ``
                      ) : (
                        <ExpansionPanelDetails className="display-block padding-top-16">
                          {formopentypeid == 2 && (
                            <div>
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission opening
                              </p>
                              {/* <p className="small-dark-secondary margin-bottom-16">
                                  Select from the X months in each [quarter]
                              </p> */}
                              <div
                                className=" margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <p className="small-dark-secondary margin-bottom-16">
                                  Select from the X day in each month.
                                </p>
                                <div className="display-flex">
                                  <div
                                    style={{
                                      width: 100,
                                      marginRight: 8,
                                      marginBottom: -16,
                                    }}
                                  >
                                    <DynamicForm
                                      fields={selectinputconverter({
                                        value:
                                          // isformalwaysopen == true
                                          //   ? 1
                                          //   :
                                          participant[3].openday,
                                        placeholder: "",
                                        label: "",
                                        options: DAYS_LIST,
                                      })}
                                      onChange={(e) =>
                                        this.handleChange("openday", e, 4)
                                      }
                                    />
                                  </div>
                                  <p className="small-dark">
                                    day of that month
                                  </p>
                                </div>
                              </div>

                              {reviewperiodtypeid != 1 && (
                                <div
                                  className="display-flex margin-bottom-16"
                                  style={{ alignItems: "center" }}
                                >
                                  <div
                                    style={{
                                      width: 100,
                                      marginRight: 8,
                                      marginBottom: -16,
                                    }}
                                  >
                                    <DynamicForm
                                      fields={selectinputconverter({
                                        value:
                                          // isformalwaysopen == true
                                          //   ? 1
                                          //   :
                                          participant[3].frequencytypeid,
                                        placeholder: "",
                                        label: "",
                                        options: monthlist,
                                      })}
                                      onChange={(e) =>
                                        this.handleChange(
                                          "frequencytypeid",
                                          e,
                                          4,
                                        )
                                      }
                                    />
                                  </div>
                                  <p className="small-dark margin-left-8">
                                    month of each [quarter]
                                  </p>
                                </div>
                              )}
                            </div>
                          )}

                          {formclosetypeid == 2 && (
                            <div className="margin-top-32">
                              <p className="normal-dark margin-bottom-8 display-flex">
                                <img
                                  className="margin-right-16"
                                  src={pointingHandIcon}
                                ></img>{" "}
                                Review submission closing
                              </p>
                              <p className="small-dark-secondary margin-bottom-16">
                                Enter number of days after which review forms
                                should close
                              </p>
                              <div
                                className="display-flex margin-bottom-16"
                                style={{ alignItems: "center" }}
                              >
                                <div style={{ width: 100, marginBottom: -16 }}>
                                  <DynamicForm
                                    fields={integerinputconverter({
                                      value: participant[3].closeday,
                                      label: "",
                                      min: 1,
                                      max: 30,
                                    })}
                                    onChange={(val) =>
                                      this.handleChange("closeday", val, 4)
                                    }
                                  />
                                </div>
                                <span className="small-dark-secondary margin-left-8">
                                  days
                                </span>
                              </div>
                            </div>
                          )}
                        </ExpansionPanelDetails>
                      )}
                    </ExpansionPanel>
                  )}
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(details));
